import { useLocation } from "@/lib/router-compat";
import { useEffect } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import NoIndex from "@/components/seo/NoIndex";
import SEOHead from "@/components/SEOHead";
import { Phone } from "lucide-react";

const PHONE = "856-200-3127";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SEOHead title="Page Not Found | Cherry Hill Recovery Center" noIndex />
      <NoIndex />
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-24">
        <div className="text-center max-w-xl">
          <p
            style={{
              fontFamily: "Helvetica, Arial, sans-serif",
              fontSize: 12,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#8B1A1A",
              fontWeight: 700,
              marginBottom: 12,
            }}
          >
            404 — Page Not Found
          </p>
          <h1
            style={{
              fontFamily: "Georgia, 'Times New Roman', serif",
              fontSize: 36,
              color: "#2C2C2C",
              margin: 0,
              lineHeight: 1.2,
            }}
          >
            We couldn't find that page.
          </h1>
          <p
            style={{
              color: "#555",
              fontSize: 16,
              lineHeight: 1.6,
              marginTop: 16,
              fontFamily: "Helvetica, Arial, sans-serif",
            }}
          >
            The page you're looking for has moved or no longer exists. Our admissions team is available 24/7 to help you find what you need.
          </p>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 12,
              justifyContent: "center",
              marginTop: 24,
            }}
          >
            <a
              href={`tel:${PHONE.replace(/-/g, "")}`}
              aria-label={`Call Cherry Hill Recovery Center at ${PHONE}`}
              style={{
                background: "#8B1A1A",
                color: "#FAF4F0",
                padding: "12px 24px",
                borderRadius: 999,
                fontWeight: 700,
                textDecoration: "none",
                fontSize: 15,
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                fontFamily: "Helvetica, Arial, sans-serif",
              }}
            >
              <Phone size={16} /> Call {PHONE}
            </a>
            <a
              href="/"
              style={{
                background: "transparent",
                color: "#8B1A1A",
                border: "2px solid #8B1A1A",
                padding: "10px 22px",
                borderRadius: 999,
                fontWeight: 700,
                textDecoration: "none",
                fontSize: 15,
                fontFamily: "Helvetica, Arial, sans-serif",
              }}
            >
              Return Home
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
